export default __webpack_public_path__ + "static/media/CNo.80-3.19b7fd15.jpg";